module.exports = __webpack_public_path__ + "img/siteloading.fd42f6cb.gif";